<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Notification Detailssss</ion-title>
          <ion-icon :icon="homeSharp" class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title>Notification Details</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <NotificationDetails />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent } from "@ionic/vue";
// @ is an alias to /src
// import NotificationDetails from "@/components/notifications/NotificationDetails.vue";
import NotificationDetails from "@/components/notification/NotificationDetails.vue";
import { homeSharp } from "ionicons/icons";

export default defineComponent ({
  name: 'notificationDetails',
  components: {
    NotificationDetails,
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonContent
  },
  data() {
    return {
      homeSharp
    }
  },
  methods: {
    homePage() {
      this.$router.push("/customer/reservation")
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    }
  }
})
</script>

<style scoped>
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #fff;
  }
  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }
  .mobile-header-toolbar ion-menu-button {
    color: #fff !important;
    margin-right: 13px;
  }
}
</style>